export const ONBOARDING_PRESENCE_ADMIN_FEEDBACK_SURVEY_KEYS = {
	PRESENCE_ADMIN_FEEDBACK_SEEN: 'presence-feedback-survey:hasAdminSeenFeedbackSurvey',
} as const;

export const PresenceAdminFeedbackSurveyOnboardingKeys = [
	...Object.values(ONBOARDING_PRESENCE_ADMIN_FEEDBACK_SURVEY_KEYS),
] as const;
